<script setup lang="ts">
  import { computed } from 'vue';
  import ChartIcon from '@/shared/assets/ChartIcon.svg';
  import MapIcon from '@/shared/assets/icons/MapIcon.svg';
  import { IconImage } from '@/shared/ui';
  import type { FieldBadgeConfiguration } from '../../../lib/field-badge-anchor';

  interface Props {
    configuration: FieldBadgeConfiguration;
    anchorStyle?: Record<string, string>;
  }

  const props = defineProps<Props>();

  const CONFIGURATION_ICON: Record<FieldBadgeConfiguration, string | object> = {
    anchor: MapIcon,
    report: ChartIcon,
  };

  const icon = computed(() => CONFIGURATION_ICON[props.configuration]);
</script>

<template>
  <span
    class="pointer-events-none absolute z-20 flex size-[20px] items-center justify-center rounded-[5px] border-2 border-solid border-[var(--color-gray-02)] bg-[var(--color-gray-07)] text-[var(--color-white-01)]"
    :style="anchorStyle"
    :data-configuration="configuration"
    aria-hidden="true"
    data-testid="field-configuration-badge"
  >
    <IconImage
      :src="icon"
      alt=""
      class="h-3 w-3"
    />
  </span>
</template>
